export default __webpack_public_path__ + "static/media/minidisko-show.6342b3fe.svg";